// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDpqixUovx-RWg1wBi3nEhzFiCZ96yZ0_E",
  authDomain: "reallivesworld-35ea5.firebaseapp.com",
  // databaseURL: "https://reallivesworld-35ea5-default-rtdb.firebaseio.com",
  databaseURL:"https://reallivesworldproduction.firebaseio.com/",
  projectId: "reallivesworld-35ea5",
  storageBucket: "reallivesworld-35ea5.appspot.com",
  messagingSenderId: "312340415963",
  appId: "1:312340415963:web:7a93f13d5002665e8753fe",
  measurementId: "G-P9SDTK30N4"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
